import { FC, Props } from "./typings";
import styles from "./styles.module.scss";

const PassedToCell: FC<Props> = ({ element }) => {
  return (
    <div className={styles.wrapper}>
      <div>{element.Pass ? element.Pass?.To : ""}</div>
    </div>
  );
};

export default PassedToCell;
